// ** Redux Imports
import { createSlice } from "@reduxjs/toolkit";
import { t } from "i18next";
import moment from "moment";
import { errorAlert } from "utils/alertHandler";

export const priceSlice = createSlice({
  name: "price",
  initialState: {
    startTime: null,
    endTime: null,
    totalPrice: null,
    discountedPrice: null,
    totalHours: 0,
    pointUsed: 0,
    voucher: null,
  },
  reducers: {
    setStartDateTime: (state, action) => {
      state.startTime = action.payload;
      state.endTime = null;
      state.totalPrice = null;
      state.discountedPrice = null;
      state.totalHours = 0;
      state.pointUsed = 0;
      state.voucher = null;
    },
    setEndDateTime: (state, action) => {
      if (state.startTime && action.payload) {
        const startTime = moment(state.startTime);
        const endTime = moment(action.payload);

        if (endTime.isBefore(startTime)) {
          errorAlert(t("invalid_end_time"));
          return;
        } else {
          state.endTime = action.payload;
          state.totalHours = Math.abs(moment.duration(moment(state.startTime).diff(moment(action.payload))).asHours());
        }
      } else {
        state.endTime = action.payload;
        state.totalHours = Math.abs(moment.duration(moment(state.startTime).diff(moment(action.payload))).asHours());
      }
    },
    setPrice: (state, action) => {
      state.totalPrice = action.payload.totalPrice;
      state.discountedPrice = action.payload.discountedPrice;
    },
    setPointUsed: (state, action) => {
      state.pointUsed = action.payload;
    },
    setVoucher: (state, action) => {
      state.voucher = action.payload;
    },
    clearVoucher: (state, action) => {
      state.voucher = null;
    },
    clearPrice: (state) => {
      state.startTime = null;
      state.endTime = null;
      state.totalPrice = null;
      state.totalHours = 0;
      state.pointUsed = 0;
    },
  },
});
export const { setStartDateTime, setEndDateTime, setPrice, setPointUsed, clearPrice, setVoucher, clearVoucher } = priceSlice.actions;

export default priceSlice.reducer;
